import React, { useContext } from 'react';
import { useDataModel } from '@thd-nucleus/data-sources';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Carousel, Loader } from '@thd-olt-component-react/core-ui';
import classNames from 'classnames/bind';
import { phpDataModel } from '../dataModel';
import { InformationAndCtaPod } from '../information-and-cta-pod/InformationAndCtaPod';
import { dataStore } from '../../php-card-matrix';
import styles from './homeservicecarousel.module.scss';

export const HomeServicePhpCarousel = () => {
  // for development
  // gets the user cookie
  const THDCustomer = typeof window !== 'undefined' ? window.THDCustomer?.default : {};
  const userId = THDCustomer?.svocID || THDCustomer?.userID || THDCustomer?.guestUserID;
  const { channel } = useContext(ExperienceContext) || {};
  const cx = classNames.bind(styles);
  const udsQuery = {
    variables: {
      userId,
      appId: channel === 'mobile' ? 'mobileweb' : 'desktop',
      apiName: 'homeservices',
      key: 'aGAQFG4j6QtVTSWqujfFYWeIU6BR5Mee',
    },
    ssr: false,
  };
  const { loading, data } = useDataModel('uds', udsQuery);
  if (loading) {
    return (
      <div className={cx('php-carousel')}>
        <Loader className={cx('php-carousel__loader')} active />
      </div>
    );
  }

  const carouselContent = data?.uds?.services?.map((service) => (
    <div key={service.id}>
      <InformationAndCtaPod service={dataStore[service.id]} />
    </div>
  ));

  const carouselPreview = {
    slidesPerView: 1,
    slidesPerGroup: 1,
  };

  return (
    <div className={cx('php-carousel')}>
      <div data-testid="php-carousel-title" className={cx('php-carousel__title')}>
        Leave Your Next Project to Us
      </div>
      {carouselContent && carouselContent.length > 0 ? (
        <Carousel
          breakpoints={{
            sm: carouselPreview,
            md: carouselPreview,
            lg: carouselPreview,
            xl: carouselPreview,
          }}
          peek={false}
          slidesPerGroup={1}
          slidesPerView={1}
        >
          {carouselContent}
        </Carousel>
      ) : (
        <div>
          <InformationAndCtaPod service={dataStore.GENERIC} />
        </div>
      )}
    </div>
  );
};
HomeServicePhpCarousel.dataModel = phpDataModel;

HomeServicePhpCarousel.propTypes = {};

HomeServicePhpCarousel.defaultProps = {};

HomeServicePhpCarousel.displayName = 'HomeServicePhpCarousel';
